import * as React from "react"
import { useSignal } from "@preact/signals-react"
import { Grid } from "@mui/material"
import { AccordionSeeker } from "@ui-seeker/core"

import ScrapingDataReviewBrandsFilter from "./BrandsFilter"
import ScrapingDataReviewCustomerFilter from "./CustomerFilter"
import ScrapingDataReviewFiltersFooter from "./Footer"
import ScrapingDataReviewMarketFilter from "./MarketFilter"
import ScrapingDataReviewRecentDataFilter from "./RecentDataFilter"
import ScrapingDataReviewSitesFilter from "./SitesFilter"


export default function ScrapingDataReviewFilters() {
    const isOpen = useSignal(true)

    return <AccordionSeeker
        title="Filters"
        TransitionProps={{ unmountOnExit: false }}
        expanded={isOpen.value}
        onChange={() => isOpen.value = !isOpen.value}
        footerActions={<ScrapingDataReviewFiltersFooter />}
    >
        <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={3}>
                <ScrapingDataReviewCustomerFilter />
            </Grid>
            <Grid item xs={12} md={3}>
                <ScrapingDataReviewMarketFilter />
            </Grid>
            <Grid item xs={12} md={3}>
                <ScrapingDataReviewSitesFilter />
            </Grid>
            <Grid item xs={12} md={3}>
                <ScrapingDataReviewBrandsFilter />
            </Grid>
            {/* The text search and the quality filters used to be here. They
                narrow the result rather than choose it, so they now live in the
                results table's own header, where they apply without Search. */}
            <Grid item xs={12} sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
                <ScrapingDataReviewRecentDataFilter />
            </Grid>
        </Grid>
    </AccordionSeeker>
}
